import React, {useEffect, useState} from 'react';
import {Table, Button, Space, Popconfirm, message, Tag, Card, Row, Col, Statistic} from 'antd';
import {PlusOutlined, EditOutlined, DeleteOutlined, EyeOutlined} from '@ant-design/icons';
import {useApi} from '../provider/ApiProvider';
import {useHistory} from 'react-router-dom';
import LayoutComponent from '../components/LayoutComponent';

const TargetLocationPage = () => {
    const {api, user} = useApi();
    const history = useHistory();
    const [targetLocations, setTargetLocations] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        fetchTargetLocations();
    }, []);

    const fetchTargetLocations = async () => {
        setLoading(true);
        try {
            console.log('Current user:', user); // Debug için kullanıcı bilgilerini yazdır
            const response = await api.get('/targetLocationRouter/all');
            if (response.status) {
                setTargetLocations(response.data);
            }
        } catch (error) {
            console.error('API Error:', error); // Hata detaylarını yazdır
            message.error('Hedef lokasyonlar yüklenirken hata oluştu');
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async (id) => {
        try {
            const response = await api.put(`/targetLocationRouter/delete/${id}`, { isActive: false });
            if (response.status) {
                message.success('Hedef lokasyon başarıyla silindi');
                fetchTargetLocations();
            }
        } catch (error) {
            message.error('Hedef lokasyon silinirken hata oluştu');
        }
    };

    const columns = [
        {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
            width: 80,
        },
        {
            title: 'Ad',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Koordinatlar',
            key: 'coordinates',
            render: (_, record) => (
                <div>
                    <div>Lat: {record.latitude}</div>
                    <div>Lng: {record.longitude}</div>
                </div>
            ),
        },
        {
            title: 'Yarıçap',
            dataIndex: 'radius',
            key: 'radius',
            render: (radius) => `${radius}m`,
        },
        {
            title: 'Renk',
            dataIndex: 'color',
            key: 'color',
            render: (color) => (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <div 
                        style={{ 
                            width: 20, 
                            height: 20, 
                            backgroundColor: color, 
                            borderRadius: 4,
                            marginRight: 8
                        }} 
                    />
                    {color}
                </div>
            ),
        },
        {
            title: 'Kapı Sayısı',
            key: 'doorCount',
            render: (_, record) => record.doors ? record.doors.length : 0,
        },
        {
            title: 'Durum',
            dataIndex: 'isActive',
            key: 'isActive',
            render: (isActive) => (
                <Tag color={isActive ? 'green' : 'red'}>
                    {isActive ? 'Aktif' : 'Pasif'}
                </Tag>
            ),
        },
        {
            title: 'İşlemler',
            key: 'actions',
            render: (_, record) => (
                <Space size="middle">
                    <Button 
                        type="primary" 
                        icon={<EyeOutlined />} 
                        size="small"
                        onClick={() => history.push(`/target-locations/view/${record.id}`)}
                    >
                        Görüntüle
                    </Button>
                    <Button 
                        type="default" 
                        icon={<EditOutlined />} 
                        size="small"
                        onClick={() => history.push(`/target-locations/edit/${record.id}`)}
                    >
                        Düzenle
                    </Button>
                    <Popconfirm
                        title="Bu hedef lokasyonu silmek istediğinizden emin misiniz?"
                        onConfirm={() => handleDelete(record.id)}
                        okText="Evet"
                        cancelText="Hayır"
                    >
                        <Button 
                            type="primary" 
                            danger 
                            icon={<DeleteOutlined />} 
                            size="small"
                        >
                            Sil
                        </Button>
                    </Popconfirm>
                </Space>
            ),
        },
    ];

    const stats = {
        total: targetLocations.length,
        active: targetLocations.filter(loc => loc.isActive).length,
        totalDoors: targetLocations.reduce((sum, loc) => sum + (loc.doors ? loc.doors.length : 0), 0),
    };

    return (
        <LayoutComponent>
            <div style={{ padding: '24px' }}>
                <div style={{ marginBottom: '24px' }}>
                    <Row gutter={16}>
                        <Col span={6}>
                            <Card>
                                <Statistic
                                    title="Toplam Lokasyon"
                                    value={stats.total}
                                    valueStyle={{ color: '#3f8600' }}
                                />
                            </Card>
                        </Col>
                        <Col span={6}>
                            <Card>
                                <Statistic
                                    title="Aktif Lokasyon"
                                    value={stats.active}
                                    valueStyle={{ color: '#1890ff' }}
                                />
                            </Card>
                        </Col>
                        <Col span={6}>
                            <Card>
                                <Statistic
                                    title="Toplam Kapı"
                                    value={stats.totalDoors}
                                    valueStyle={{ color: '#722ed1' }}
                                />
                            </Card>
                        </Col>
                        <Col span={6}>
                            <Card>
                                <Button 
                                    type="primary" 
                                    icon={<PlusOutlined />}
                                    onClick={() => history.push('/target-locations/add')}
                                    style={{ width: '100%', height: '100%' }}
                                >
                                    Yeni Lokasyon Ekle
                                </Button>
                            </Card>
                        </Col>
                    </Row>
                </div>

                <Card title="Hedef Lokasyonlar">
                    <Table
                        columns={columns}
                        dataSource={targetLocations}
                        rowKey="id"
                        loading={loading}
                        pagination={{
                            pageSize: 10,
                            showSizeChanger: true,
                            showQuickJumper: true,
                            showTotal: (total, range) => 
                                `${range[0]}-${range[1]} / ${total} kayıt`,
                        }}
                    />
                </Card>
            </div>
        </LayoutComponent>
    );
};

export default TargetLocationPage;
